import { Component, inject, OnInit, Signal, signal, WritableSignal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { SelectUsersListComponent } from '@app/shared/components/select-users-list/select-users-list.component';
import { ActiveCompanyService } from '@app/shared/services/active-company.service';
import { UsersDataService } from '@app/shared/services/users-data.service';
import { Company } from '@app/shared/types/models/company/company.model';
import { SelectUsersToCompanyGroupDialogData } from '@app/shared/types/models/group/group.model';
import { User } from '@app/shared/types/models/user/user.model';
import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-osh-select-users-dialog',
  imports: [MatDialogModule, TranslatePipe, UiDialogComponent, SelectUsersListComponent],
  templateUrl: './osh-select-users-dialog.component.html'
})
export class OshSelectUsersDialogComponent implements OnInit {
  private readonly activeCompanyService: ActiveCompanyService = inject(ActiveCompanyService);
  private readonly dialogRef: MatDialogRef<OshSelectUsersDialogComponent> = inject(
    MatDialogRef<OshSelectUsersDialogComponent>
  );
  private readonly usersDataService: UsersDataService = inject(UsersDataService);
  private readonly dialogData: SelectUsersToCompanyGroupDialogData = inject(MAT_DIALOG_DATA);

  protected readonly activeCompany: Signal<Company | undefined> = this.activeCompanyService.activeCompany;
  protected readonly companyUsers: Signal<User[]> = this.usersDataService.getCompanyUsers(this.activeCompany()?.id);

  protected readonly selectedUsers: WritableSignal<string[]> = signal<string[]>(undefined);
  protected readonly preselectedUsers: WritableSignal<string[]> = signal<string[]>(undefined);
  protected readonly lockedUser: WritableSignal<string> = signal<string>(undefined);

  public constructor() {
    this.preselectedUsers.set(this.dialogData.preselectedUsers.map(user => user.id));
    this.lockedUser.set(this.dialogData.lockedUser?.id);
  }

  public ngOnInit(): void {
    this.selectedUsers.set([...this.preselectedUsers()]);
  }

  protected save(): void {
    const idsToAdd = this.selectedUsers().filter(id => !this.preselectedUsers().includes(id));
    const idsToRemove = this.preselectedUsers().filter(id => !this.selectedUsers().includes(id));

    const usersToAdd = this.companyUsers().filter(user => idsToAdd.includes(user.id));
    const usersToRemove = this.companyUsers().filter(user => idsToRemove.includes(user.id));
    this.dialogRef.close({ usersToAdd, usersToRemove });
  }
}
